// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"layout__sectionWrapper___DJunm","section":"layout__section___RMFZ9"};